// Copyright (c) 2020 WiseTime. All rights reserved.

import { combineEpics } from "redux-observable"
import persistToolbarFilters from "./persistToolbarFilters"
import loadToolbarFilters from "./loadToolbarFilters"
import countFilteredTimeRowsByDay from "./countFilteredTimeRowsByDay"
import createTimelineMarker from "./createTimelineMarker"
import { storagePrefix } from "../../../../app/config"

export const TOOLBAR_FILTERS_KEY = storagePrefix + "toolbar"

export default combineEpics(
  persistToolbarFilters,
  loadToolbarFilters,
  countFilteredTimeRowsByDay,
  createTimelineMarker,
)
